import { getCurrentLanguage, getPath } from "../../store/directories/selectors";
import { deleteCookie } from "../../untils/cookies";
import { useActions } from "../actions";
import { endpoints as getEndpoints, util } from "../../store/user/user.api";
import { useAppDispatch } from "../useAppDispatch";

export const useLogout = () => {
    const { clearTkn, clearRegistrationState } = useActions();
    const dispatch = useAppDispatch();
    /** Только на этапе render хука — нельзя вызывать getCurrentLanguage внутри async-колбэка (там useSelector). */
    const currentLanguage = getCurrentLanguage();

    //чистим при любых условиях чтобы не было бага

    const clearProfile = () => dispatch(
        util.updateQueryData(
            "getProfile",
            undefined,
            (user) => user = null
        )
    );

    /**
     * @param redirectAfter — куда перейти после очистки сессии.
     *   По умолчанию: /{lang}/{первый сегмент пути}/ (как раньше).
     *   Строка: полный путь, например /ru/specialist/auth.
     *   false: без перехода (нужно для logout(false) в других местах приложения).
     */
    return async (redirectAfter?: string | false) => {
        clearProfile()
        deleteCookie("tkn");
        clearTkn();
        await clearRegistrationState();
        if (redirectAfter === false) {
            return;
        }
        const segments = getPath();
        window.location.href =
            typeof redirectAfter === "string" && redirectAfter.length > 0
                ? redirectAfter
                : `/${currentLanguage}/${segments[1]}/`;
    };
};
